module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[116]603.c923ffe.woff2";